import {useMemo} from 'react';
import {useSelector} from 'react-redux';

import {simpleTableSelector} from 'utils/tables';

import {matingSelector} from '../../model';
import {MatingLoadingId} from '../../types';

const FEMALE = 'FEMALE';

const isCowsFilterFormLoading = (loading: Array<MatingLoadingId>): boolean =>
    loading.includes('animalLists')
    || loading.includes('criteriaDefinitions')
    || loading.includes('criteriaLists')
    || loading.includes('breeders')
;

const isCowsFilterFormReloading = (loading: Array<MatingLoadingId>): boolean =>
    loading.includes('criteriaListDetails')
;

interface CowTabState {
    /** Whether the tab is still loading or initializing. */
    tabLoading: boolean;
    /** Whether the form itself should be reloaded. */
    formReloading: boolean;
}

/**
 * Computes loading state for the cow selection tab.
 *
 * @param loading Mating loading flags.
 * @returns Derived tab loading flags.
 */
export const useCowsTabState = (
    loading: Array<MatingLoadingId>,
): CowTabState => {
    const animalListsTag = useSelector(matingSelector.animalListsTag);
    const criteriaListsTag = useSelector(matingSelector.criteriaListsTag);
    const matingCowsTableState = useSelector(simpleTableSelector.tableState('matingCows'));
    const cowsPage = useSelector(matingSelector.femaleAnimalsPage);

    const listsLoading = useMemo(
        () => !animalListsTag.contains(FEMALE) || !criteriaListsTag.contains(FEMALE),
        [animalListsTag, criteriaListsTag],
    );
    const formLoading = useMemo(() => isCowsFilterFormLoading(loading) || listsLoading, [loading, listsLoading]);
    const formReloading = useMemo(() => isCowsFilterFormReloading(loading), [loading]);
    const tableInitializing = useMemo(
        () => !(matingCowsTableState && cowsPage.nonEmpty),
        [cowsPage.nonEmpty, matingCowsTableState],
    );

    return {
        tabLoading: formLoading || tableInitializing,
        formReloading,
    };
};
